<template>
  <div class="animated fadeIn equipmentList bgV2">
    <b-row>
      <b-col md="12">
        <gofix-tab
          class="mt-3 contractSorTab"
          :data="contract_tab"
          :query-param="{id:$route.params.id}"
          activeKey="sor"
          arrows>
          <template slot="gofixTab:sor">
            <div class="equipment row-split">
              <b-row>
                <b-col md="3">
                  <sor-group :terms="contractTerms" @importItem="openModalImport" @nodeChange="nodeChange" ref="sorGroup"></sor-group>
                </b-col>
                <b-col md="9" class="pl-md-0">
                  <sor-items :group="sor_group" :terms="contractTerms" @importSuccess="processImportSuccess" ref="sorItem"></sor-items>
                </b-col>
              </b-row>
            </div>
          </template>
        </gofix-tab>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  const sorItems = () => import('./c-main/sor-items')
  const sorGroup = () => import('./c-main/sor-group')
  import tabData from '@/data/_tabs';

  export default {
    name: 'sor',
    components: {
      sorGroup,
      sorItems
    },
    data () {
      return {
        sor_group: {},
        contract_tab:tabData.client_contract,
        contractTerms: {}
      }
    },
    created () {
      if(!this.$route.params.hasOwnProperty('id') || isNaN(this.$route.params.id)) {
        return this.$router.push(`/v2/contract-client`);
      }
      
      if(this.ClientContractID && !this.contractTerms.id && this.ClientContractID.contract_terms){
        this.contractTerms = this.ClientContractID.contract_terms[0];
      }
    },
    computed: {
      ...mapGetters({
        ClientContractID: 'ContractController/ClientContractID'
      })
    },
    watch: {
      ClientContractID: function(val,old){
        if (!val) {
          return this.$router.push('/v2/contract-client')
        }
        this.contractTerms = val.contract_terms[0];
      }
    },
    methods:{
      nodeChange(node) {
        this.sor_group = node.data;
      },
      /*--- Table event-------------------------------*/
      openModalImport(){
        this.$refs.sorItem.$refs.gofixTable.openImportModal();
      },
      processImportSuccess() {
        this.$refs.sorGroup.reloadGroup();
      }
    }
  }
</script>
